import { zCreateAgentInput } from '@/general/src/agent/utils/createAgent/input.js'

export const zCreateAgentForAdminEndpointInput = zCreateAgentInput
